import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../../../../icons";
const BufferingIndicator = () => {
    return (_jsx("div", { "aria-hidden": true, className: "absolute inset-0 z-0 block flex h-full w-full items-center justify-center bg-black/50 opacity-0 group-data-[loading]:opacity-100 group-data-[waiting]:opacity-100", children: _jsx(Icon, { name: "loader-circle", className: "animate-spin", color: "white", size: "lg" }) }));
};
BufferingIndicator.displayName = "BufferingIndicator";
export default BufferingIndicator;
